import { type Meta } from '../types/docs';
import { AUTOMATION_RUNS_LOAD_MORE_LOCATIONS, AUTOMATIONS_ANALYTICS_CATEGORY_META_PARAM } from './automationsAnalytics';

const META: Meta = {
  description: 'The user loads more automation runs in a paginated list',
  name: 'automation_runs_load_more',
  params: [
    AUTOMATIONS_ANALYTICS_CATEGORY_META_PARAM,
    {
      description: 'The automation whose runs are being loaded',
      name: 'automation_id',
      required: true,
      type: 'string',
    },
    {
      description: 'Where the load-more action occurred',
      name: 'location',
      required: true,
      type: 'enum',
      values: [...AUTOMATION_RUNS_LOAD_MORE_LOCATIONS],
    },
  ],
};

export default META;
